import {Accordion, AccordionSummary, RadioGroup, styled} from "@mui/material";

export const ProductDetailsContainer = styled(Accordion)(() => ({
    backgroundColor: '#fff',
    width: '100%',
    maxWidth: '43rem',
    borderRadius: '4px',
    scrollMarginTop: '5rem',
    '&.MuiPaper-root::before': {
        height: 0
    }
}));

export const ProductDetailsSummary = styled(AccordionSummary)(() => ({
    justifyContent: 'space-between',
    width: '100%',

    '& .MuiAccordionSummary-content': {
        flexDirection: 'column',
    }
}));

export const ProductDetailsDescriptionContainer = styled('div')(() => ({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    gap: '1rem'
}));

export const ParcelConditionRadioGroup = styled(RadioGroup)(() => ({
    alignItems: 'center',
    justifyContent: 'flex-start',
    width: '100%',

    '& .MuiFormControlLabel-root': {
        margin: 0
    }
}));

